<template>
  <iframe :src="webUrl+'/admin/platform/friendly.link'"></iframe>
</template>

<script>
export default {
  name: "friendly",
  setup(){
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>